<template>
  <div class="app">
    <navbar></navbar>
    <notifications></notifications>
    <section class="section " id="main">
      <div class="columns ">
        <div class="column is-paddingless aside-column">
          <aside-menu></aside-menu>
        </div>
        <div class="column is-main-column">
          <div class="page-wrapper" :key="$route.fullPath">
            <header-page v-if="!$route.meta.hideHeader"></header-page>
            <div class="page">
              <div class="page-slot" :class="$route.name">
                <slot></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AsideMenu from '@/components/AsideMenu'
import Navbar from '@/components/Navbar'
import HeaderPage from '@/components/HeaderPage'

export default {
  name: 'app',
  components: {
    HeaderPage,
    Navbar,
    AsideMenu
  }
}
</script>
<style scoped lang="scss">
#main {
  padding: 0;
}
input {
  font-size: 0.9rem;
  height: 1.5rem;
}
textarea {
  font-size: 0.9rem;
}

.columns {
  margin-top: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.aside-column {
  background-color: #464646;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 31;
  width: 160px;
}
.is-main-column {
  padding: 0;
  margin-left: 160px;
  background-color: #f3f3f3;
  .level {
    padding: 2rem;
    margin-bottom: 0;
  }
  .page {
    background: #fff;
    border-top: 2px solid #dbdbdb;
    border-bottom: 2px solid #dbdbdb;
    .page-slot {
      padding: 1rem 2rem;
    }
    .system_settings {
      padding: 0 0.75rem;
    }
  }
}
</style>
